import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { updateCookieCampaign } from '../utils'

import logo from './vv2-logo.png'
import posterMobile from './vv2-poster-mobile.webp'
import posterDesktop from './vv2-poster-desktop.jpg'

export const ViceVersa = () => {
   const data = {
      videoDesktop: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/disney-vice-versa-2/vv2-video-desktop.mp4',
      videoMobile: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/disney-vice-versa-2/vv2-video-mobile.mp4',
      posterDesktop: posterDesktop,
      posterMobile: posterMobile,
      CTA: {
         label: 'Acheter',
         URL: 'https://r.orange.fr/r/SVOD_CM_R_Vice-Versa-2',
         analytics: {
            pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event_disney',
            oeventCategory: 'zone_evenementielle',
            oeventAction: 'disney',
            oeventLabel: 'https://r.orange.fr/r/SVOD_CM_R_Vice-Versa-2',
            oeventOther: JSON.stringify({
               track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event_disney',
            }),
         },
      },
   }

   // Video
   const [nbPlayed, setNbPlayed] = useState(0)
   const [isPlaying, setIsPlaying] = useState(true)
   const [isMuted, setIsMuted] = useState(true)
   const [hasEnded, setHasEnded] = useState(false)
   const [isContentShacking, setIsContentShacking] = useState(false)
   const [videoSource, setVideoSource] = useState(window.innerWidth >= 736 ? data.videoDesktop : data.videoMobile)
   const [videoPoster, setVideoPoster] = useState(window.innerWidth >= 736 ? data.posterDesktop : data.posterMobile)
   const videoRef = useRef(null)
   const playPauseButtonRef = useRef(null)
   const soundButtonRef = useRef(null)

   const handleMuteUnmute = (e) => {
      e.preventDefault()
      const videoElement = videoRef.current
      videoElement.muted = !isMuted
      setIsMuted(!isMuted)
   }

   const handleTimeUpdate = () => {
      const videoElement = videoRef.current
      const currentTime = videoElement.currentTime
      if (currentTime >= 8.4 && isContentShacking === false) {
         setIsContentShacking(true)
      } else {
         setIsContentShacking(false)
      }
   }

   useEffect(() => {
      // Video
      const videoElement = videoRef.current
      const playPauseButton = playPauseButtonRef.current
      const soundButton = soundButtonRef.current

      const handlePlayPause = (e) => {
         e.preventDefault()
         setHasEnded(false)
         if (videoElement.paused) {
            videoElement.play()
            setIsPlaying(true)
         } else {
            videoElement.pause()
            setIsPlaying(false)
         }
      }

      const handleVideoEnded = () => {
         setIsPlaying(false)
         setHasEnded(true)
         // Rejouer la vidéo après 3 secondes   (3 fois max)
         setNbPlayed((prevNbPlayed) => {
            const newNbPlayed = prevNbPlayed + 1
            if (newNbPlayed < 3) {
               setTimeout(() => {
                  videoElement.play()
                  setIsPlaying(true)
                  setHasEnded(false)
               }, 3000)
            }
            return newNbPlayed
         })
      }

      const setTimeoutId = setTimeout(() => {
         videoElement.src = '' // Evite au navigateur de continuer à télécharger la vidéo
      }, 5000)

      const handlePlaying = () => {
         clearTimeout(setTimeoutId)
         videoElement.style.opacity = 1
         playPauseButton.style.opacity = 1
         soundButton.style.opacity = 1
      }

      playPauseButton.addEventListener('click', handlePlayPause)
      videoElement.addEventListener('ended', handleVideoEnded)
      videoElement.addEventListener('playing', handlePlaying)
      videoElement.addEventListener('timeupdate', handleTimeUpdate)

      videoElement.addEventListener('canplay', () => {
         setTimeout(() => {
            videoElement.play()
         }, 2000)
      })

      return () => {
         playPauseButton.removeEventListener('click', handlePlayPause)
         videoElement.removeEventListener('ended', handleVideoEnded)
         videoElement.removeEventListener('playing', handlePlaying)
         videoElement.removeEventListener('timeupdate', handleTimeUpdate)
      }
   }, [])

   useEffect(() => {
      const videoElement = videoRef.current
      const handleResize = () => {
         const newVideoSource = window.innerWidth >= 736 ? data.videoDesktop : data.videoMobile
         const newVideoPoster = window.innerWidth >= 736 ? data.posterDesktop : data.posterMobile
         if (newVideoSource !== videoSource) {
            setVideoSource(newVideoSource)
            setVideoPoster(newVideoPoster)
            videoElement.load() // Reload the video with the new source
            setHasEnded(false)
            setIsPlaying(true)
         }
      }

      window.addEventListener('resize', handleResize)

      return () => {
         window.removeEventListener('resize', handleResize)
      }
   }, [videoSource, data.videoDesktop, data.videoMobile])

   useEffect(() => {
      // update the cookie for the vice versa campaign (3 days because it's supposed to last 2 days)
      updateCookieCampaign('vice_versa', 3)
   }, [])

   return (
      <div class="campagneViceVersa">
         <a
            href={data.CTA.URL}
            data-pdb-zid={data.CTA.analytics.pdbZid}
            data-oevent-category={data.CTA.analytics.oeventCategory}
            data-oevent-action={data.CTA.analytics.oeventAction}
            data-oevent-label={data.CTA.analytics.oeventLabel}
            data-oevent-other={data.CTA.analytics.oeventOther}
         >
            <img src={videoPoster} class="poster" alt="" />
            <video
               id="bgVideo"
               ref={videoRef}
               playsinline // Mobile browsers will play the video right where it is instead of the default, which is to open it up fullscreen while it plays.
               // autoplay
               preload="auto"
               muted
               // poster={videoPoster}
            >
               <source src={videoSource} type="video/mp4" />
            </video>

            <div class="content-wrapper">
               <div class={`content ${isContentShacking ? 'shake' : ''}`}>
                  <img src={logo} alt="Disney-Pixar Vice-versa 2" class="title mb-1" />
                  <div>
                     <h2 class="subtitle h4 mb-1 pb-0">Disponible maintenant <br/>en achat digital</h2>
                     <span class="btn btn-primary btn-inverse">{data.CTA.label}</span>
                  </div>
               </div>
            </div>

            <button
               type="button"
               class={`video__playpause ${hasEnded ? 'icon icon-reload' : isPlaying ? 'video__playpause--pause' : 'video__playpause--play'}`}
               ref={playPauseButtonRef}
            ></button>
            <button type="button" onClick={handleMuteUnmute} class={`video__sound icon ${isMuted ? 'icon-volume-none' : 'icon-volume-mid'}`} ref={soundButtonRef}></button>
         </a>
      </div>
   )
}

// const CampagneImage = (props) => {
//    return (
//       <div class="campagne">
//          <img src={props.title} alt="" class="title" />
//          <picture>
//             <source srcset={props.imageSmallX2} media="(max-width: 735px)" />
//             <img src={props.imageLargeX2} alt="" class="imageFond" />
//          </picture>
//          <div class="content">
//             <h3 class="subtitle h4" dangerouslySetInnerHTML={{ __html: tagParser(props.subtitle) }} />
//             <a
//                href={props.button.URL}
//                class="btn btn-primary btn-inverse"
//                data-pdb-zid={props.button.analytics.pdbZid}
//                data-oevent-category={props.button.analytics.oeventCategory}
//                data-oevent-action={props.button.analytics.oeventAction}
//                data-oevent-label={props.button.analytics.oeventLabel}
//                data-oevent-other={props.button.analytics.oeventOther}
//             >
//                {props.button.label}
//             </a>
//             <span class="das">{props.DAS}</span>
//          </div>
//       </div>
//    )
// }
